import { ApiResponse, UserDetails } from "../Models";

export const loginResponseMockup: ApiResponse<UserDetails> = {
    statusCode: 200,
    error: null,
    data: {
        name: "Oshri",
        role: "OpenFieldAgriculture",
        email: "oshri@gmail.com",
        expertise: "1",
        country: "IL",
        region: "173",
        mainInterest: "OFA",
        language: "en",
    },
};
